import * as React from "react"
import { Paper, Typography, Box } from "@mui/material"


// ---------------------------------------------------------------------------
// PropertySection — the one visual container used throughout the property
// page (Location and Bien tabs alike).
//
// DECISION: every card on the old page had its own idea of a "section" —
// different padding, different header treatments, some with CardHeader +
// divider, some with an overline label, some with nothing at all. That
// mismatch is a big part of why the page read as disharmonious. Centralising
// the section chrome here means "current lease", "history", "documents" and
// "property details" all look like they belong to the same page, because
// they're rendered by the same sixty lines of code.
//
// DECISION: a plain outlined Paper (no shadow), not an elevated Card. With
// five-plus sections now sharing a page, a stack of shadowed cards reads as
// "boxes inside boxes". A hairline border gives just enough separation
// without adding visual weight.
//
// `action` renders on the same row as the title, right-aligned — used by
// PropertyHistoryCard for its Paiements/Ré-indexations switch.
// ---------------------------------------------------------------------------

const TITLE_SX = { fontWeight: 700, fontSize: "1.05rem" }

export function SectionTitle({ children, ...rest }) {
    return (
        <Typography variant="h6" sx={TITLE_SX} {...rest}>
            {children}
        </Typography>
    )
}

export default function PropertySection({ title, action, children, ...rest }) {
    return (
        <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 } }} {...rest}>
            {(title || action) && (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: 2 }}>
                    {title && <SectionTitle>{title}</SectionTitle>}
                    {action}
                </Box>
            )}
            {children}
        </Paper>
    )
}
